import WebLayout from "../layout/WebLayout";
import { Link } from "react-router-dom";

function Buyer() {
  return (
    <WebLayout pageName={Buyer}>
      <div className="product-dContent__box">
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-description"
            role="tabpanel"
            aria-labelledby="pills-description-tab"
            tabIndex="0"
          >
            <div className="mb-20">
              <h6 className="mt-10 mb-10">1. Registration & Eligibility</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  Buyers must register on IndianMSME.org with accurate details
                  (Name, Business Name, GSTIN for B2B buyers, Contact Details).
                </li>
                <li>
                  IndianMSME.org reserves the right to verify and approve buyer
                  registrations.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">2. Ordering & Payment</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  Orders once placed cannot be cancelled after confirmation
                  unless approved under the cancellation policy.
                </li>
                <li>
                  Payments must be made through authorized payment modes on
                  IndianMSME.org.
                </li>
                <li>
                  IndianMSME.org ensures secured transactions and does not store
                  sensitive payment details.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">3. Pricing & Offers</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  Prices listed are subject to market fluctuations and may
                  change without prior notice.
                </li>
                <li>
                  Discounts, promotional offers, and bulk purchase benefits are
                  subject to platform policies.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">4. Delivery & Logistics</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  a) IndianMSME.org ensures door-to-door delivery of all orders
                  via its logistics partners.
                </li>
                <li>
                  Upon receiving an order, the Manufacturer Seller must confirm
                  stock availability and keep the stock ready for dispatch.
                </li>
                <li>
                  Estimated delivery timelines are provided, but delays due to
                  unforeseen circumstances are not the platform’s
                  responsibility.
                </li>
                <li>
                  Buyers must provide a valid delivery address and ensure
                  someone is available to receive the order.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">5. Returns & Refunds</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  a) Returns are accepted only for damaged, defective, or
                  incorrect items as per the Return & Cancellation Policy.
                </li>
                <li>
                  b) Refunds, if applicable, will be processed within 7-10
                  business days after verification.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">6. Product Quality & Complaints</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  IndianMSME.org ensures that all listed products meet quality
                  standards.
                </li>
                <li>
                  Buyers must report any quality issues within 48 hours of
                  receiving the product.
                </li>
                <li>
                  Complaints will be investigated, and resolutions will be
                  provided as per platform policy.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">7. Intellectual Property & Usage</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  Buyers are not allowed to resell or distribute products under
                  unauthorized brand names.
                </li>
                <li>
                  Unauthorized use of IndianMSME.org content, trademarks, or
                  branding is strictly prohibited.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">8. Dispute Resolution & Liability</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  Any disputes will be addressed through a grievance redressal
                  mechanism before legal action.
                </li>
                <li>
                  IndianMSME.org is not liable for indirect losses such as
                  business loss, profit loss, or any external damage due to
                  order delays.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">9. Termination & Compliance</h6>
              <ul className="list-inside mt-10 ms-16">
                <li className="text-gray-400 mb-4">
                  IndianMSME.org reserves the right to block or suspend buyer
                  accounts violating platform policies.
                </li>
                <li className="text-gray-400 mb-4">
                  Buyers must comply with applicable tax regulations (GST,
                  invoicing, etc.).
                </li>
              </ul>
            </div>
            <p className="mb-10">
              By purchasing from IndianMSME.org, you agree to these Terms &
              Conditions.
            </p>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg shadow-md text-center">
            <h3 className="text-lg font-semibold text-gray-700 mb-2">
              Need Help? Contact Us
            </h3>
            <div className="flex flex-col gap-2">
              <Link
                to="mailto:help@indianmsme.org"
                className="py-2 px-4 rounded-lg shadow-md"
              >
                📧 help@indianmsme.org
              </Link>
              <Link
                to="tel:9990060509"
                className="py-2 px-4 rounded-lg shadow-md"
              >
                📞 +91-9990060509
              </Link>
              <Link
                to="tel:8800001242"
                className="py-2 px-4 rounded-lg shadow-md"
              >
                📞 +91-8800001242
              </Link>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default Buyer;
